/* Bubbly: kit de festa por tema (sections/bubbly-festa-kit.liquid) */
(function () {
  function money(cents) {
    var fmt = window.bubblyMoneyFormat || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2);
    var comma = v.replace('.', ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount') return v;
      if (k === 'amount_no_decimals') return Math.round(cents / 100);
      return comma;
    });
  }

  function init(root) {
    var d = root.dataset;
    var minimo = parseInt(d.minimo, 10) || 10;
    var guests = root.querySelector('[data-guests]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-kit-item]'));
    var countEl = root.querySelector('[data-kit-count]');
    var totalEl = root.querySelector('[data-kit-total]');
    var progEl = root.querySelector('[data-kit-progress]');
    var addBtn = root.querySelector('[data-kit-add]');
    var errEl = root.querySelector('[data-kit-error]');
    var modal = root.querySelector('[data-kit-modal]');
    var modalBody = root.querySelector('[data-kit-modal-conteudo]');
    var modalToggle = root.querySelector('[data-kit-modal-toggle]');
    var modalItem = null;
    var mexidos = new WeakSet();

    function on(li) { return li.dataset.on === '1'; }
    function qtyInput(li) { return li.querySelector('[data-kit-qty]'); }
    function max(li) { return parseInt(li.dataset.max, 10) || 99; }
    function qty(li) { return Math.min(max(li), Math.max(1, parseInt(qtyInput(li).value, 10) || 1)); }

    function setOn(li, v) {
      li.dataset.on = v ? '1' : '0';
      li.classList.toggle('is-selected', v);
      var b = li.querySelector('[data-kit-toggle]');
      b.setAttribute('aria-pressed', v ? 'true' : 'false');
      b.textContent = v ? '✓ ' + d.txtNoKit : d.txtAdicionar;
    }

    function suggest() {
      var n = Math.max(1, parseInt(guests.value, 10) || 1);
      items.forEach(function (li) {
        if (li.dataset.porConvidado !== '1' || mexidos.has(li)) return;
        var u = parseInt(li.dataset.unidades, 10) || 0;
        if (u > 0) qtyInput(li).value = Math.min(max(li), Math.max(1, Math.ceil(n / u)));
      });
    }

    function update() {
      var n = 0, elegiveis = 0, total = 0, grupos = {};
      items.forEach(function (li) {
        if (!on(li)) return;
        var q = qty(li);
        n += q;
        // Etiqueta sem-desconto-kit: entra no kit mas não conta para o desconto
        if (li.dataset.contaDesconto !== '0') elegiveis += q;
        total += q * (parseInt(li.dataset.price, 10) || 0);
        grupos[li.dataset.grupo] = true;
      });
      root.querySelectorAll('[data-grupo-check]').forEach(function (el) {
        el.classList.toggle('is-done', !!grupos[el.dataset.grupoCheck]);
      });
      countEl.textContent = n === 1 ? d.txtArtigo : d.txtArtigos.replace('__N__', n);
      totalEl.textContent = money(total);
      var falta = minimo - elegiveis;
      progEl.textContent = falta <= 0 ? d.txtDesconto : falta === 1 ? d.txtFaltaUm : d.txtFaltam.replace('__N__', falta);
      progEl.classList.toggle('is-ok', falta <= 0);
      progEl.style.setProperty('--p', Math.min(100, Math.round((elegiveis / minimo) * 100)) + '%');
      addBtn.disabled = n === 0;
      if (modalItem) syncModal();
    }

    function syncModal() {
      modalToggle.textContent = on(modalItem) ? '✓ ' + d.txtNoKit : d.txtAdicionar;
    }

    function openModal(li) {
      var tpl = li.querySelector('[data-kit-det-tpl]');
      if (!tpl || !modal.showModal) return;
      modalItem = li;
      modalBody.innerHTML = '';
      modalBody.appendChild(tpl.content.cloneNode(true));
      syncModal();
      modal.showModal();
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (modal.open) modal.close();
    }

    modal.addEventListener('close', function () {
      modalItem = null;
      document.body.style.overflow = '';
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-kit-fechar]')) closeModal();
    });
    modalToggle.addEventListener('click', function () {
      if (!modalItem) return;
      setOn(modalItem, !on(modalItem));
      update();
      closeModal();
    });

    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-step]');
      if (step) {
        guests.value = Math.min(100, Math.max(1, (parseInt(guests.value, 10) || 1) + parseInt(step.dataset.step, 10)));
        suggest();
        update();
        return;
      }
      var li = e.target.closest('[data-kit-item]');
      if (!li) return;
      var qs = e.target.closest('[data-qty-step]');
      if (qs) {
        var inp = qtyInput(li);
        inp.value = Math.min(max(li), Math.max(1, qty(li) + parseInt(qs.dataset.qtyStep, 10)));
        mexidos.add(li);
        if (!on(li)) setOn(li, true);
        update();
        return;
      }
      if (e.target.closest('[data-kit-toggle]')) {
        setOn(li, !on(li));
        update();
        return;
      }
      if (e.target.closest('[data-kit-det]')) openModal(li);
    });

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-guests]')) {
        suggest();
      } else if (e.target.matches('[data-kit-qty]')) {
        var li = e.target.closest('[data-kit-item]');
        e.target.value = qty(li);
        mexidos.add(li);
      } else if (e.target.matches('[data-kit-variant]')) {
        var li2 = e.target.closest('[data-kit-item]');
        var opt = e.target.selectedOptions[0];
        li2.dataset.variant = opt.value;
        li2.dataset.price = opt.dataset.price;
        li2.dataset.max = opt.dataset.max;
        li2.dataset.contaDesconto = opt.dataset.conta || '1';
        qtyInput(li2).value = qty(li2);
        var p = li2.querySelector('[data-kit-preco]');
        if (p) p.textContent = opt.dataset.preco;
      }
      update();
    });

    addBtn.addEventListener('click', function () {
      var lista = items.filter(on).map(function (li) {
        return { id: parseInt(li.dataset.variant, 10), quantity: qty(li) };
      });
      if (!lista.length) return;
      addBtn.disabled = true;
      addBtn.classList.add('loading');
      errEl.hidden = true;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lista })
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || '');
            return j;
          });
        })
        .then(function () {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (err) {
          errEl.textContent = d.txtErro + ' ' + (err.message || '');
          errEl.hidden = false;
          addBtn.disabled = false;
          addBtn.classList.remove('loading');
        });
    });

    suggest();
    update();
  }

  function start() {
    document.querySelectorAll('[data-bubbly-kit]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
